import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import "../../assets/titli/css/titli.css";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import io from "socket.io-client";
const base_url = process.env.REACT_APP_API_URL;

const iconData = [
  { name: "umbrella", icon: "☔" },
  { name: "soccer", icon: "⚽" },
  { name: "sun", icon: "☀️" },
  { name: "lamp", icon: "🪔" },
  { name: "cow", icon: "🐄" },
  { name: "bucket", icon: "🪣" },
  { name: "kite", icon: "🪁" },
  { name: "lattu", icon: "🪀" },
  { name: "rose", icon: "🌹" },
  { name: "butterfly", icon: "🦋" },
  { name: "dove", icon: "🕊️" },
  { name: "rabbit", icon: "🐰" },
];

const getIconByName = (name) => {
  const item = iconData.find((d) => d.name === name);
  return item ? item.icon : "❓";
};

const Titli = () => {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const socketRef = useRef(null);

  const isInitialLoad = useRef(true);
  const lastGameIdRef = useRef(null);

  const [isLoggedIn, setIsLoggedIn] = useState(true);

  const [popupActive, setPopupActive] = useState(false);
  const [activeTab, setActiveTab] = useState("my");
  const [selected, setSelected] = useState(null);
  const [betAmount, setBetAmount] = useState(10);
  const [timmer, setTimmer] = useState(120);
  const [page, setPage] = useState(1);
  const [page2, setPage2] = useState(1);
  const limit = 100;

  const [totalPages, setTotalPages] = useState(1);
  const [totalPages2, setTotalPages2] = useState(1);
  const [userBetData, setUserBetData] = useState([]);
  const [wallet, setWallet] = useState(0);
  const [totalBet, setTotalBet] = useState(0);
  const [winAmount, setWinAmount] = useState(0);
  const [loseAmount, setLoseAmount] = useState(0);
  const [winStatus, setWinStatus] = useState(0);
  const [period, setPeriod] = useState("");
  const [resultStatus, setResultStatus] = useState(0);
  const [displayResults, setDisplayResults] = useState([null, null, null]);
  const [isSpinning, setIsSpinning] = useState(false);
  const [gameHistory, setGameHistory] = useState([]);
  const [gameStatus, setGameStatus] = useState(false);
  const [myBetDetailsActive, setMyBetDetailsActive] = useState(null);
  const [showResultPopup, setShowResultPopup] = useState(false);
  const [betPlacedActive, setBetPlacedActive] = useState(false);
  const [betPlaceProgress, setBetPlaceProgress] = useState(false);
  const [showHowToPlay, setShowHowToPlay] = useState(false);
  const [countDown, setCountDown] = useState(false);
  const [soundEnabled] = useState(true);

  const rollIntervalRef = useRef(null);
  const total = Number(betAmount || 0);

  const handleBalanceSelect = (value) => {
    playSound(audioFiles.click);
    setBetAmount(value);
  };

  /* 🔊 AUDIO */
  const audioFiles = {
    bet: new Audio("/assets/titli/audio/bet.mp3"),
    spin: new Audio("/assets/titli/audio/spin2.mp3"),
    click: new Audio("/assets/titli/audio/click.mp3"),
    countdown1: new Audio("/assets/titli/audio/countdown1.mp3"),
    countdown2: new Audio("/assets/titli/audio/countdown2.mp3"),
    countdown3: new Audio("/assets/titli/audio/countdown3.mp3"),
  };

  const playSound = (audio) => {
    if (!soundEnabled) return;
    audio.currentTime = 0;
    audio.play().catch(() => {});
  };

  const stopSound = (audio) => {
    if (!audio) return;
    audio.pause();
    audio.currentTime = 0;
  };

  /* 🔁 DATA FETCHERS */
  const getTitliGameData = async () => {
    const res = await axios.get(`${base_url}/api/get/titliGameData`, {
      params: { page, limit },
    });
    if (res.data?.success) {
      setPeriod(res.data.gameId);
      setTimmer(res.data.timmer);
      setGameHistory(res.data.titliData);
      setTotalPages(res.data.totalPages);
      setDisplayResults(
        res.data.result
          ? res.data.result.split(", ").map(getIconByName)
          : [null, null, null],
      );
    }
  };

  const getWithAuthTitliGameData = async () => {
    try {
      const res = await axios.get(
        `${base_url}/api/get/getWithAuthTitliGameData`,
        {
          params: { page, page2, limit },
          headers: {
            Authorization: token,
          },
        },
      );

      // 🔐 AUTH FAILED → fallback to guest
      if (res.data?.success === false) {
        setIsLoggedIn(false);
        await getTitliGameData();
        return;
      }

      // ✅ AUTH SUCCESS
      setIsLoggedIn(true);
      setPeriod(res.data.gameId);
      setWallet(res.data.money);
      setTotalBet(res.data.totalBet);
      setWinAmount(res.data.winAmount);
      setLoseAmount(res.data.loseAmount);
      setWinStatus(res.data.winStatus);
      setGameHistory(res.data.titliData);
      setUserBetData(res.data.titliUserBetData);
      setTotalPages(res.data.totalPages);
      setTotalPages2(res.data.totalPages2);
      setTimmer(res.data.timmer);
      setDisplayResults(
        res.data.result
          ? res.data.result.split(", ").map(getIconByName)
          : [null, null, null],
      );
    } catch (err) {
      console.error("Auth API error:", err);
      setIsLoggedIn(false);
      await getTitliGameData();
    }
  };

  const refreshGameData = () => {
    if (isLoggedIn) getWithAuthTitliGameData();
    else getTitliGameData();
  };

  /* 🔌 SOCKET */
  useEffect(() => {
    if (!isLoggedIn) return;

    socketRef.current = io(base_url, {
      auth: { token: localStorage.getItem("token") },
    });

    socketRef.current.on("connect", () => {
      socketRef.current.emit("joinRoom", "user");
    });

    socketRef.current.on("newGame", refreshGameData);
    socketRef.current.on("newBetTitli", refreshGameData);
    socketRef.current.on("gameUpdated", refreshGameData);

    return () => socketRef.current?.disconnect();
  }, []);

  /* 🔁 INITIAL LOAD */
  useEffect(() => {
    const init = async () => {
      try {
        await getWithAuthTitliGameData();
      } catch {
        await getTitliGameData();
      }
    };
    init();
  }, [page, page2]);

  /* ⏱ TIMER */
  useEffect(() => {
    if (timmer <= 20) {
      if (countDown === false) {
        playSound(audioFiles.countdown1);
        setCountDown(true);
      }
    } else {
      if (countDown === true) {
        setCountDown(false);
      }
    }

    if (timmer === 9 && countDown === true) {
      stopSound(audioFiles.countdown1);
      playSound(audioFiles.countdown1);
    }

    if (timmer === 120) {
      if (isInitialLoad.current) return;

      setIsSpinning(true);
      setShowResultPopup(false);
      playSound(audioFiles.spin);

      rollIntervalRef.current = setInterval(() => {
        setDisplayResults([
          iconData[Math.floor(Math.random() * iconData.length)].icon,
          iconData[Math.floor(Math.random() * iconData.length)].icon,
          iconData[Math.floor(Math.random() * iconData.length)].icon,
        ]);
      }, 80);

      setTimeout(() => {
        clearInterval(rollIntervalRef.current);
        rollIntervalRef.current = null;
        setIsSpinning(false);
        refreshGameData();
      }, 3000);
    }

    if (timmer === 86) {
      if (isInitialLoad.current) return;
      if (winStatus === 1 || winStatus === 2) {
        setShowResultPopup(true);

        setTimeout(() => {
          setShowResultPopup(false);
        }, 4000);
      }
    }

    if (timmer < 0) {
      setTimmer(120);
    }

    const t = setTimeout(() => setTimmer((p) => p - 1), 1000);
    return () => clearTimeout(t);
  }, [timmer]);

  useEffect(() => {
    return () => {
      if (rollIntervalRef.current) {
        clearInterval(rollIntervalRef.current);
      }
    };
  }, []);

  /* 🎯 PLACE BET */
  const placeBet = async () => {
    if (!isLoggedIn) return toast.error("Please login first");
    if (gameStatus) return toast.error("Game is processing");
    if (betPlaceProgress === true) return toast.error("Bet is processing");
    setBetPlaceProgress(true);

    const res = await axios.post(
      `${base_url}/api/place/titliBet`,
      { game_id: period, icon_name: selected, amount: betAmount },
      {
        headers: {
          Authorization: token,
        },
      },
    );

    if (res.data?.success) {
      playSound(audioFiles.bet);
      toast.success("Bet placed successfully");
      setPopupActive(false);
      setBetPlacedActive(true);
      setBetPlaceProgress(false);
      refreshGameData();
    } else {
      toast.error(res.data?.message || "Failed");
      setBetPlaceProgress(false);
    }
  };

  const pendingBetMap = React.useMemo(() => {
    const map = {};
    userBetData.forEach((bet) => {
      if (bet.status === 0) {
        const icons = bet.bet.split(", ");
        icons.forEach((icon) => {
          map[icon] = (map[icon] || 0) + Number(bet.betAmount || 0);
        });
      }
    });
    return map;
  }, [userBetData]);

  useEffect(() => {
    if (period) {
      if (lastGameIdRef.current === null) {
        lastGameIdRef.current = period;
        isInitialLoad.current = false; // ✅ first load finished
      } else if (lastGameIdRef.current !== period) {
        // ✅ new game started
        lastGameIdRef.current = period;
      }
    }
  }, [period]);

  return (
    <>
      <div
        className="titli-container"
        style={{
          overflow:
            popupActive === true || countDown === true ? "hidden" : "scroll",
        }}
      >
        {countDown === true && (
          <div className="count-down text-white">
            <div className="outer-circle">{timmer}</div>
          </div>
        )}
        <div className="header">
          <span
            className="title"
            onClick={() => {
              playSound(audioFiles.click);
              // navigate(-1);
            }}
          >
            <ArrowLeft /> Back
          </span>
          <div className="header-right">
            <span className="money">₹{parseFloat(wallet).toFixed(2)}</span>
          </div>
        </div>

        <div className="period_div">
          <div className="period_div_left">
            <span>Total Bet :-</span>
            <span>{totalBet}</span>
          </div>
          <div>
            <button
              className="how-to-play-btn"
              onClick={() => {
                playSound(audioFiles.click);
                setShowHowToPlay(true);
              }}
            >
              ℹ️ How to Play
            </button>
          </div>
          <div className="period_div_right">
            <span id="timmer">{timmer}s</span>
          </div>
        </div>

        {/* History Icon Section */}
        <div className="history-section">
          <div className="history-icon-section">
            {gameHistory.slice(0, 30).map((item, index) => (
              <div key={index} className="history-icon-card">
                {item.result.split(", ").map((iconName, iconIndex) => {
                  const foundIcon = iconData.find(
                    (icon) => icon.name === iconName.trim(),
                  );

                  return (
                    <span key={iconIndex} className="history-icon-badge">
                      {foundIcon ? foundIcon.icon : "❓"}
                    </span>
                  );
                })}
              </div>
            ))}
          </div>
        </div>

        {/* Top Stamps */}
        <div className="stamps-row">
          {[0].map((_, index) => (
            <div key={index} className="stamp butterfly-stamp">
              <div className={`stamp-content ${isSpinning ? "spinning" : ""}`}>
                {displayResults[index] || "❓"}
              </div>
            </div>
          ))}
        </div>

        {/* Icons */}
        <div className="icons-row first-row">
          {iconData.map((data, index) => (
            <div
              key={index}
              className="icon"
              onClick={() => {
                playSound(audioFiles.click);
                setPopupActive(true);
                setSelected(data.name);
              }}
            >
              {data.icon}

              {pendingBetMap[data.name] > 0 && (
                <span className="icon-bet-amount">
                  ₹{pendingBetMap[data.name]}
                </span>
              )}
            </div>
          ))}
        </div>

        <div className="titli-offer-line">₹10 के बनाओ ₹100 💥</div>

        {/* Tabs */}
        <div className="titli-tabs">
          <button
            className={`tab ${activeTab === "my" ? "active" : ""}`}
            onClick={() => {
              playSound(audioFiles.click);
              setActiveTab("my");
            }}
          >
            My History
          </button>
          <button
            className={`tab ${activeTab === "game" ? "active" : ""}`}
            onClick={() => {
              playSound(audioFiles.click);
              setActiveTab("game");
            }}
          >
            Game History
          </button>
        </div>

        {/* Tab Content */}
        <div className="tab-content">
          {activeTab === "game" ? (
            <div className="history-table">
              <table>
                <thead>
                  <tr>
                    <th>Game ID</th>
                    <th>Result</th>
                  </tr>
                </thead>
                <tbody>
                  {gameHistory && gameHistory.length > 0 ? (
                    gameHistory.map((row, i) => (
                      <tr key={i}>
                        <td>{row.game_id}</td>
                        <td>
                          {(row.result || "").split(", ").map((item, index) => {
                            const foundIcon = iconData.find(
                              (icon) => icon.name === item.trim(),
                            );
                            return (
                              <span
                                key={index}
                                style={{
                                  marginRight: "8px",
                                  fontSize: "20px",
                                  display: "inline-flex",
                                  alignItems: "center",
                                }}
                              >
                                {foundIcon ? foundIcon.icon : item}
                              </span>
                            );
                          })}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="4"
                        style={{ textAlign: "center", color: "#888" }}
                      >
                        No game history found!
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              <div className="pagination">
                <button
                  onClick={() => {
                    playSound(audioFiles.click);
                    setPage((prev) => Math.max(prev - 1, 1));
                  }}
                  disabled={page === 1}
                >
                  <ArrowLeft />
                </button>
                <span>
                  Page {page} of {totalPages}
                </span>
                <button
                  onClick={() => {
                    playSound(audioFiles.click);
                    setPage((prev) => Math.min(prev + 1, totalPages));
                  }}
                  disabled={page === totalPages}
                >
                  <ArrowRight />
                </button>
              </div>
            </div>
          ) : (
            <div className="history-table">
              <table>
                <thead>
                  <tr>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  {userBetData.length > 0 ? (
                    userBetData.map((row, i) => (
                      <tr key={i}>
                        <td
                          onClick={() => {
                            playSound(audioFiles.click);
                            setMyBetDetailsActive(
                              myBetDetailsActive === row.id ? null : row.id,
                            );
                          }}
                        >
                          {/* My Bets */}
                          <div className="myBetTr">
                            <div className="my_bet_left_side_div">
                              <div className="myBetIcon">
                                {(row.bet || "")
                                  .split(", ")
                                  .map((item, index) => {
                                    const foundIcon = iconData.find(
                                      (icon) => icon.name === item.trim(),
                                    );
                                    return (
                                      <span key={index}>
                                        {foundIcon ? foundIcon.icon : item}
                                      </span>
                                    );
                                  })}
                              </div>
                              <div>
                                <h5>{row.game_id}</h5>
                                <h5>
                                  {new Date(row.created_at).toLocaleString()}
                                </h5>
                              </div>
                            </div>
                            <div className="my_bet_right_side_div">
                              <div
                                className={
                                  row.status === 1
                                    ? "myBetStatusWin"
                                    : row.status === 2
                                      ? "myBetStatusLose"
                                      : "myBetStatusPending"
                                }
                              >
                                <h5>
                                  {row.status === 1
                                    ? "Win"
                                    : row.status === 2
                                      ? "Lose"
                                      : "Pending"}
                                </h5>
                              </div>
                              <h5
                                className={
                                  row.status === 1
                                    ? "greenColor"
                                    : row.status === 2
                                      ? "redColor"
                                      : "orangeColor"
                                }
                              >
                                {row.status === 1
                                  ? "+" + parseFloat(row.winAmount).toFixed(2)
                                  : "-" + parseFloat(row.betAmount).toFixed(2)}
                              </h5>
                            </div>
                          </div>

                          {/* Details Section */}
                          <div
                            className="myBetDetails"
                            style={{
                              display:
                                myBetDetailsActive === row.id
                                  ? "block"
                                  : "none",
                            }}
                          >
                            <h5>Details</h5>

                            <div className="myBetDetailRow">
                              <p>Game ID</p>
                              <p>{row.game_id}</p>
                            </div>
                            <div className="myBetDetailRow">
                              <p>Bet Amount</p>
                              <p className="redColor">
                                {parseFloat(row.betAmount).toFixed(2)}
                              </p>
                            </div>
                            <div className="myBetDetailRow">
                              <p>Selected</p>
                              <p>
                                {(row.bet || "")
                                  .split(", ")
                                  .map((item, index) => {
                                    const foundIcon = iconData.find(
                                      (icon) => icon.name === item.trim(),
                                    );
                                    return (
                                      <span key={index}>
                                        {foundIcon ? foundIcon.icon : item}
                                      </span>
                                    );
                                  })}
                              </p>
                            </div>
                            <div className="myBetDetailRow">
                              <p>Result</p>
                              <p className="orangeColor">
                                {row.result
                                  ? (row.result || "")
                                      .split(", ")
                                      .map((item, index) => {
                                        const foundIcon = iconData.find(
                                          (icon) => icon.name === item.trim(),
                                        );
                                        return (
                                          <span
                                            key={index}
                                            style={{ marginLeft: "8px" }}
                                          >
                                            {foundIcon ? foundIcon.icon : item}
                                          </span>
                                        );
                                      })
                                  : "Pending"}
                              </p>
                            </div>
                            <div className="myBetDetailRow">
                              <p>Win/Lose</p>
                              <p
                                className={
                                  row.status === 1
                                    ? "greenColor"
                                    : row.status === 2
                                      ? "redColor"
                                      : "orangeColor"
                                }
                              >
                                {row.status === 1
                                  ? "+" + parseFloat(row.winAmount).toFixed(2)
                                  : "-" + parseFloat(row.betAmount).toFixed(2)}
                              </p>
                            </div>
                            <div className="myBetDetailRow">
                              <p>Available Balance</p>
                              <p className="greenColor">
                                {parseFloat(row.current_money).toFixed(2)}
                              </p>
                            </div>
                            <div className="myBetDetailRow">
                              <p>Time</p>
                              <p>{new Date(row.created_at).toLocaleString()}</p>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td>Bet not available!</td>
                    </tr>
                  )}
                </tbody>
              </table>

              <div className="pagination">
                <button
                  onClick={() => {
                    playSound(audioFiles.click);
                    setPage2((prev) => Math.max(prev - 1, 1));
                  }}
                  disabled={page2 === 1}
                >
                  <ArrowLeft />
                </button>
                <span>
                  Page {page2} of {totalPages2}
                </span>
                <button
                  onClick={() => {
                    playSound(audioFiles.click);
                    setPage2((prev) => Math.min(prev + 1, totalPages2));
                  }}
                  disabled={page2 === totalPages2}
                >
                  <ArrowRight />
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Popup Section */}
        {popupActive && (
          <div className="bottom-section">
            <div className="titli-bet">
              <div className="popup">
                <div className="popup-header">
                  <h2>Place Bet</h2>
                  <div className="select-box">
                    <span>Selected</span>
                    <strong>{getIconByName(selected)}</strong>
                  </div>
                </div>

                <div className="popup-body">
                  {/* Bet Amount */}
                  <div className="balance-section">
                    <label>Enter Amount</label>
                    <input
                      type="number"
                      min="1"
                      value={betAmount}
                      onChange={(e) => setBetAmount(e.target.value)}
                      className="bet-input"
                      placeholder="Enter amount"
                    />
                  </div>

                  {/* Quick Amount Buttons */}
                  <div className="balance-options">
                    {[10, 50, 100, 1000].map((val) => (
                      <button
                        key={val}
                        className={Number(betAmount) === val ? "active" : ""}
                        onClick={() => handleBalanceSelect(val)}
                      >
                        {val}
                      </button>
                    ))}
                  </div>
                </div>

                <div className="popup-footer">
                  <button
                    className="cancel"
                    onClick={() => {
                      playSound(audioFiles.click);
                      setPopupActive(false);
                    }}
                  >
                    Cancel
                  </button>
                  <button className="total" onClick={placeBet}>
                    Total amount ₹{total.toFixed(2)}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* 🎉 Win / Lose Popup */}
      {showResultPopup && (
        <div className="result-popup-overlay">
          <div
            className={`result-popup ${
              winStatus === 1
                ? "popup-win"
                : winStatus === 2
                  ? "popup-lose"
                  : "popup-pending"
            }`}
          >
            <div className="popup-emoji">
              {winStatus === 1 ? "🎉" : winStatus === 2 ? "😢" : "⏳"}
            </div>
            <h2>
              {winStatus === 1
                ? "You Win!"
                : winStatus === 2
                  ? "You Lose!"
                  : ""}
            </h2>
            <p style={{ color: "#fff" }}>
              {winStatus === 1
                ? `You earned ₹${winAmount.toFixed(2)}`
                : winStatus === 2
                  ? `You lost your bet`
                  : `Waiting for result...`}
            </p>
          </div>
        </div>
      )}

      {/* 🧭 How to Play Popup */}
      {showHowToPlay && (
        <div
          className="howto-overlay"
          onClick={() => {
            playSound(audioFiles.click);
            setShowHowToPlay(false);
          }}
        >
          <div className="howto-popup" onClick={(e) => e.stopPropagation()}>
            <h2>How to Play Titli 🦋</h2>
            <div className="howto-content">
              <h3>🎮 Quick Start</h3>
              <ol>
                <li>
                  <strong>Join the Game:</strong> Log in and open Titli.
                </li>
                <li>
                  <strong>Select an Icon:</strong> Tap any icon to bet.
                </li>
              </ol>
              <h3>💰 Customize Your Bet</h3>
              <ul>
                <li>
                  <b>Balance:</b> Choose ₹10, ₹50, ₹100, or ₹1,000, etc.
                </li>
                <li>
                  <b>Multiplier:</b> X10.
                </li>
              </ul>
              <h3>⏱️ Watch the Round</h3>
              <p>Timer counts down. When 0, results appear.</p>
              <h3>🏆 Check Results</h3>
              <p>View Game History & My History for past bets.</p>
            </div>

            <button
              className="close-howto"
              onClick={() => {
                playSound(audioFiles.click);
                setShowHowToPlay(false);
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Titli;
